export default {
  quizWrongResults: [],
  domainsElements: [],
  proficiencyHistory: {},
  domainConcepts: [],
  quizResultCaches: [],
  catList: [],
  userRanking: {},
  rankingScores: [],
  catExpHistories: {},
  flightBoxRewardHistories: [],
};
